import script from "./pc-module-chi-square-analysis-1.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-chi-square-analysis-1.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-chi-square-analysis-1.vue?vue&type=style&index=0&id=830fa32a&lang=scss"

const __exports__ = script;

export default __exports__